import {
  GoogleAutocompletePredictionWrapper,
  GoogleAutocompleteResultsAddress,
  GoogleAutocompleteResultsTitle,
} from './styles';

export const GoogleAutocompletePrediction = ({
  description,
  handlePredictionSelection,
  onKeyDown,
  prediction,
  title,
}) => {
  const onPredictionClick = () =>
    handlePredictionSelection && handlePredictionSelection(prediction);
  return (
    <GoogleAutocompletePredictionWrapper
      onClick={onPredictionClick}
      tabIndex="0"
      onKeyDown={onKeyDown(onPredictionClick)}
    >
      {title && (
        <GoogleAutocompleteResultsTitle>{title}</GoogleAutocompleteResultsTitle>
      )}
      {description && (
        <GoogleAutocompleteResultsAddress>
          {description}
        </GoogleAutocompleteResultsAddress>
      )}
    </GoogleAutocompletePredictionWrapper>
  );
};
